export const CardStatus = {
  Active: 'Active',
  Blocked: 'Blocked',
  Closed: 'Closed',
  Delinquent: 'Delinquent',
  Frozen: 'Frozen',
  Inactive: 'Inactive',
} as const;
export type CardStatus = (typeof CardStatus)[keyof typeof CardStatus];
